import { FormGrid } from '@app/components/various/Form';
import { Skeleton } from '@app/components/various/Skeleton';
import { useTranslation } from 'react-i18next';

export const LookbookSettingsGeneralFormSkeleton = () => {
  const { t } = useTranslation(['common', 'lookbook']);

  return (
    <div className="space-y-5">
      <section className="box space-y-5">
        <h3 className="heading-3">{t('common:general')}</h3>
        <p className="text-neutral-40 body-2">{t('lookbook:lookbook_settings_general_subtitle')}</p>
        <FormGrid rowGap="medium">
          <Skeleton type="input" label />
          <Skeleton type="input" label />
          <Skeleton type="input" label />
          <Skeleton type="rectangle" className="h-6" />
        </FormGrid>
      </section>

      <section className="box space-y-5">
        <h3 className="heading-3">{t('lookbook:remove_lookbook')}</h3>
        <p className="text-neutral-40 body-2">{t('lookbook:remove_lookbook_description')}</p>
        <Skeleton type="rectangle" className="h-6" />
      </section>
    </div>
  );
};
